import { api } from './client'

export interface FunnelSegmentRow {
  id: string
  name: string
  color: string
  order: number
}

export interface FunnelSegmentPayload {
  name: string
  color?: string
  order?: number
}

export async function fetchFunnelSegments(): Promise<FunnelSegmentRow[]> {
  const r = await api.get<FunnelSegmentRow[]>('/funnel-segments')
  return r.data
}

export async function createFunnelSegment(payload: FunnelSegmentPayload): Promise<FunnelSegmentRow> {
  const r = await api.post<FunnelSegmentRow>('/funnel-segments', payload)
  return r.data
}

export async function updateFunnelSegment(id: string, payload: Partial<FunnelSegmentPayload>): Promise<FunnelSegmentRow> {
  const r = await api.patch<FunnelSegmentRow>(`/funnel-segments/${id}`, payload)
  return r.data
}

export async function deleteFunnelSegment(id: string): Promise<void> {
  await api.delete(`/funnel-segments/${id}`)
}
